import PropTypes from 'prop-types'
import { twMerge } from 'tailwind-merge'
import memoize from './memoize'

function flattenClassNames() {
  // eslint-disable-next-line prefer-rest-params
  return [...arguments].flat(10).filter(Boolean).join(' ')
}

const memoizedFlattenClassNames = memoize(flattenClassNames)

export default function cn() {
  // eslint-disable-next-line prefer-rest-params
  const flattedClassNames = memoizedFlattenClassNames(...arguments)
  return twMerge(flattedClassNames)
}

cn.propType = PropTypes.oneOfType([PropTypes.string, PropTypes.array])
